import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiBoStateFilter, ApiOmpBoState } from "./types";

interface BoStatesListResponse {
    listData: ApiOmpBoState[];
}

/**
 * Транспортный слой OMP — состояния БО.
 */
export const boStatesApi = {
    /**
     * Загружает состояния БО по заданному фильтру.
     * Запрос уходит в endpoint `bo/state.loadListByFilter`.
     */
    load: async (flt: ApiBoStateFilter, config?: RequestConfig): Promise<ApiOmpBoState[]> => {
        const data = await ompApiClient.postOmega<BoStatesListResponse>("bo/state.loadListByFilter", { flt }, config);
        return data.listData;
    },
} as const;
